var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "57px",
    viewBox: "0 0 73 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.1,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 73,
    height: 57
  }), /*#__PURE__*/React.createElement("g", {
    id: "baseLogo-(1)",
    transform: "translate(0.000000, 14.000000)",
    fill: "#1E296B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3,3.7 L13.2,3.7 L13.2,29.1 L9.3,29.1 L9.3,3.7 L0.2,3.7 L0.2,0.7 L22.3,0.7 C22.3,0.7 22.3,3.7 22.3,3.7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,16.8 L30.3,29.1 L26.5,29.1 L26.5,0.7 L36.8,0.7 C39.9,0.7 42.3,1.4 43.9,2.8 C45.5,4.2 46.4,6.2 46.4,8.8 C46.4,10.3 46,11.5 45.3,12.6 C44.6,13.7 43.4,14.5 42,15.2 C43.6,15.7 44.7,16.5 45.4,17.7 C46.1,18.9 46.4,20.2 46.4,21.9 L46.4,24.6 C46.4,25.5 46.5,26.3 46.7,27 C46.9,27.7 47.2,28.3 47.7,28.7 L47.7,29.1 L43.7,29.1 C43.2,28.7 42.9,28 42.7,27.1 C42.6,26.2 42.5,25.4 42.5,24.4 L42.5,21.8 C42.5,20.3 42.1,19 41.2,18.1 C40.3,17.2 39.1,16.7 37.6,16.7 L30.3,16.7 L30.3,16.8 Z M30.3,13.7 L36.4,13.7 C38.6,13.7 40.1,13.3 41.1,12.5 C42.1,11.7 42.5,10.4 42.5,8.7 C42.5,7.1 42,5.9 41.1,5 C40.2,4.1 38.7,3.7 36.8,3.7 L30.4,3.7 L30.4,13.7 L30.3,13.7 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,21.9 C68.4,20.6 67.9,19.5 66.9,18.6 C65.9,17.7 64.2,17 61.7,16.4 C58.7,15.7 56.3,14.6 54.7,13.2 C53,11.8 52.2,10 52.2,7.9 C52.2,5.7 53.1,3.8 54.9,2.3 C56.7,0.8 59.1,0.1 62,0.1 C65.1,0.1 67.6,1 69.4,2.7 C71.2,4.4 72.1,6.4 72.1,8.6 L72.1,8.7 L68.4,8.7 C68.4,7 67.8,5.7 66.7,4.7 C65.6,3.7 64,3.2 62,3.2 C60.1,3.2 58.6,3.6 57.6,4.5 C56.6,5.4 56.1,6.5 56.1,7.9 C56.1,9.1 56.7,10.2 57.8,11 C58.9,11.8 60.7,12.6 63.2,13.2 C66.2,13.9 68.5,15 70,16.5 C71.5,18 72.3,19.7 72.3,21.9 C72.3,24.2 71.4,26 69.5,27.4 C67.6,28.8 65.2,29.5 62.2,29.5 C59.4,29.5 56.9,28.7 54.7,27.2 C52.5,25.7 51.5,23.6 51.5,21 L51.5,20.9 L55.2,20.9 C55.2,22.7 55.9,24.1 57.2,25.1 C58.5,26.1 60.2,26.5 62.2,26.5 C64.1,26.5 65.7,26.1 66.8,25.3 C67.9,24.4 68.4,23.3 68.4,21.9 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLogo);
export default __webpack_public_path__ + "static/media/baseLogo.4cc2adb9b1865f35bda64aa3b19a05dd.svg";
export { ForwardRef as ReactComponent };